<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="success"
        ><v-icon>send</v-icon><span>Mark Order Dispatched</span></v-btn
      >
    </template>
    <v-card>
      <v-card-title>
        <h2>Mark Order as Dispatched</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-if="cartIsTracked"
            value="Tracked Shipping"
            label="Shipping Option"
            prepend-icon="flight_takeoff"
            disabled
          ></v-text-field>
          <v-text-field
            v-if="cartIsTracked"
            v-model="trackingNumber"
            label="Tracking Number"
            prepend-icon="local_shipping"
            :rules="inputRules"
          ></v-text-field>
          <v-text-field
            v-if="!cartIsTracked"
            v-model="trackingNumber"
            label="Package Number"
            prepend-icon="local_shipping"
          ></v-text-field>
          <v-text-field
            v-model="cartId"
            label="CartId"
            prepend-icon="shopping_cart"
            disabled
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn @click="submit" class="success mx-1" :loading="loading"
            >Mark Order Dispatched</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String
    },
    cartIsTracked: {
      type: Boolean
    }
  },
  data() {
    return {
      trackingNumber: "",
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      loading: false,
      dialog: false
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        cartApi
          .markOrderAsDispatched(this.cartId, this.trackingNumber)
          .then(() => {
            this.loading = false;
            this.dialog = false;
            this.$emit("orderDispatched");
          });
      }
    }
  }
};
</script>
